export default __webpack_public_path__ + "static/media/1-oz-gold-bar-pamp-suisse-lady-fortuna-veriscan-9999-fine-in-assay--132083449651848945.18c2cd27.jpg";